import axios from 'axios'
import { Toast } from 'vant'
import store from '@/store'

// 统一使用同源相对路径 /api/ ：
//   - 本地开发：由 devServer 代理转发到 PHP 后端（127.0.0.1:8000）
//   - 生产环境：由 Nginx 将 /api/xxx 重写到 /server/index.php?s=/api/xxx
const request = axios.create({
  baseURL: '/api/',
  timeout: 25000
})

request.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  // 管理后台接口使用管理员独立 token，其余接口使用商城用户 token
  // 后台数据接口（/goods/ /order/ /stat/ /category/）通过 X-Admin 头标记
  const isAdminApi = config.headers['X-Admin'] === 1 ||
    (typeof config.url === 'string' && config.url.indexOf('/admin/') === 0)
  const adminToken = window.localStorage.getItem('admin_token') || ''
  config.headers['Access-Token'] = isAdminApi ? adminToken : store.getters.token
  config.headers.platform = 'H5'

  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
request.interceptors.response.use(function (response) {
  // 2xx 范围内的状态码都会触发该函数。
  // 对响应数据做点什么
  const res = response.data

  // 兼容非 JSON 响应：后端若在 JSON 前输出了 PHP 警告/错误文本（例如 PHP 8.0+
  // 的 libxml_disable_entity_loader 废弃提示），response.data 会是字符串而非对象，
  // 此时 res.status / res.message 均为 undefined，直接走下面的逻辑会 reject undefined，
  // 控制台就会打印「支付失败 undefined」。这里统一转成可读的 Error，方便定位问题。
  if (!res || typeof res !== 'object') {
    Toast.clear()
    const preview = typeof res === 'string' ? res.slice(0, 200) : String(res)
    console.error('[request] 接口返回了非 JSON 内容，请检查后端 PHP 错误日志：', preview)
    return Promise.reject(new Error('服务器返回格式异常，请稍后重试'))
  }

  // 响应拦截器统一处理错误提示
  if (res.status !== 200) {
    Toast.clear()
    // 401 = 登录失效 / 未登录：清除本地登录态，保证客户端显示为未登录
    if (res.status === 401) {
      const isAdminApi = (response.config.headers && response.config.headers['X-Admin'] === 1) ||
        (typeof response.config.url === 'string' && response.config.url.indexOf('/admin/') === 0)
      if (isAdminApi) {
        // 管理后台 token 失效，清除后台登录态
        if (window.localStorage.getItem('admin_token')) {
          window.localStorage.removeItem('admin_token')
          Toast(res.message)
        }
      } else if (store.getters.token) {
        // 商城用户 token 失效，退出登录（清空用户/购物车/地址等状态）
        store.dispatch('user/logOut')
        Toast(res.message)
      }
      // 已在未登录状态时静默处理，避免轮询接口反复弹提示
    } else {
      Toast(res.message)
    }
    return Promise.reject(res.message)
  } else {
    Toast.clear()
  }
  return res
}, function (error) {
  // 超出 2xx 范围的状态码都会触发该函数。
  // 对响应错误做点什么
  Toast.clear()
  Toast('网络错误，请稍后重试')
  return Promise.reject(error)
})

export default request